if (typeof window !== 'undefined' && !window.Element.prototype.matches) {
  // @ts-ignore
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

if (typeof window !== 'undefined' && !window.Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this; //eslint-disable-line @typescript-eslint/no-this-alias

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
}